import { gsap } from 'gsap';

export class Accordion {
    constructor(container, options) {
        this.container = typeof (container) === 'string' ? document.querySelector(container) : container;
        this.options = Object.assign({ enableCondition: () => { return true; }, startOpen: true, multiOpen: false }, options);
    }

    init() {
        this.items = this.container?.querySelectorAll('.accordion-item');
        this._setState();
        window.addEventListener('resize', function () {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(this._setState.bind(this), 100);
        }.bind(this));
    }

    disable() {
        this.items.forEach((item, i) => {
            if (item._timeline) {
                item._timeline.pause();
            }
            var title = item.querySelector('.accordion-title');
            var marker = item.querySelector('.accordion-marker');
            var others = title.parentElement.querySelectorAll(':scope>*:not(.accordion-title):not(.accordion-marker)');
            gsap.set(title, { clearProps: 'all' });
            gsap.set(marker, { clearProps: 'all' });
            gsap.set(others, { clearProps: 'all' });
            item.removeEventListener('click', item._clickHandler);
            item._open = false;
            delete item._timeline;
            delete item._clickHandler;
        });
    }

    _setState() {
        var wasActive = this._active;
        this._active = this.options.enableCondition();
        if (this._active) {
            this._buildAnimations();
        }
        else if (wasActive) {
            this.disable();
        }
    }

    _buildAnimations() {
        this.items.forEach((item, i) => {
            if (item._timeline) {
                item._timeline.progress(1);
            }
            var title = item.querySelector('.accordion-title');
            var marker = item.querySelector('.accordion-marker');
            var others = title.parentElement.querySelectorAll(':scope>*:not(.accordion-title):not(.accordion-marker)');
            item._timeline = gsap.timeline({
                paused: true
            })
                .addLabel('start')
                .from(title, .3, { marginTop: 0, marginBottom: 0 }, 'start')
                .to(marker, .3, { opacity: .6, rotation: 180 }, 'start')
                .from(others, .3, { overflow: 'hidden', height: 0, marginTop: 0, marginBottom: 0 }, 'start');
            if (!item._clickHandler) {
                item._clickHandler = function (e) {
                    this._toggleAccordionItem(e, item);
                }.bind(this);
                item.addEventListener('click', item._clickHandler);
            }
            if (this.options.startOpen && i === 0) {
                item._open = true;
                item._timeline.progress(1);
            }
        })
    }

    _toggleAccordionItem(e, item) {
        item._open = !item._open;
        var isLink = item.tagName.toLowerCase() === 'a';
        if (item._open) {
            if (isLink) {
                e.preventDefault();
            }
            item._timeline.play();
            if (!this.options.multiOpen) {
                this.items.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem._open = false;
                        otherItem._timeline.reverse();
                    }
                })
            }
        }
        else {
            if (!isLink) {
                item._timeline.reverse();
            }
        }

    }
}